<template>
  <div class="card-wrapper">
    <b-card v-for="ct in linkList" :key="ct.id" class="mb-3">
      <div class="d-xs-flex justify-content-between align-items-center">
        <div class="d-lg-flex d-block flex-grow-1">
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ ct.link }}
          </p>
        </div>
        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i @click="showInfoModal(ct.id)" class="glyph-icon simple-icon-pencil datalist-icon mr-2"></i>
          <i @click="handleDelete(ct.id)" class="glyph-icon simple-icon-trash datalist-icon"></i>
        </div>
      </div>
    </b-card>

    <!-- Modals -->
    <b-modal id="editCategoryModal" ref="editCategoryModal" size="lg" :title="'Edit Category'">
      <b-row v-if="!ctLoading">
        <b-colxx xxs="12">
          <b-card class="mb-4">
            <b-form @submit.prevent="onSubmit" class="av-tooltip">
              <b-form-group :label="$t('pages.categories.categoryImage') + ' EN'">
                <b-form-file v-model="editForm.image_en" accept="image/*" @change="onImageEnChange"></b-form-file>
              </b-form-group>
              <div class="my-2 mb-4">
                <img
                  v-if="!imageEnUploaded && imageEnUrl !== null"
                  :src="`${apiUrl}/${imageEnUrl}`"
                  class="object-cover"
                  draggable="false"
                  width="100"
                  height="100"
                  alt="EN category image"
                />
                <div v-else-if="imageEnUploaded && editForm.image_en" class="mt-2">
                  <small class="text-success">✓ Yangi rasm tanlandi</small>
                </div>
              </div>

              <b-form-group :label="$t('pages.categories.categoryImage') + ' RU'">
                <b-form-file v-model="editForm.image_ru" accept="image/*" @change="onImageRuChange"></b-form-file>
              </b-form-group>
              <div class="my-2 mb-4">
                <img
                  v-if="!imageRuUploaded && imageRuUrl !== null"
                  :src="`${apiUrl}/${imageRuUrl}`"
                  class="object-cover"
                  draggable="false"
                  width="100"
                  height="100"
                  alt="RU category image"
                />
                <div v-else-if="imageRuUploaded && editForm.image_ru" class="mt-2">
                  <small class="text-success">✓ Yangi rasm tanlandi</small>
                </div>
              </div>

              <b-form-group :label="$t('menu.links') + ' ' + $t('anyform.forSite')">
                <b-form-input type="text" v-model="$v.editForm.link.$model" :state="!$v.editForm.link.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.link.required">
                  {{ $t('formErrors.enterName') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pages.manufacturers.chooseCategory') + ' ' + $t('anyform.forApp')">
                <v-select
                  v-model="editForm.categoryId"
                  :options="requirements"
                  :reduce="(req) => req.id"
                  label="name"
                />
              </b-form-group>

              <b-form-group>
                <b-form-checkbox v-model="editForm.active">{{ $t('anyform.showInTheSite') }}</b-form-checkbox>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox v-model="editForm.mobile">{{ $t('anyform.showInTheApp') }}</b-form-checkbox>
              </b-form-group>

              <b-button type="submit" variant="primary" class="mt-2">
                {{ $t('buttons.save') }}
              </b-button>
            </b-form>
          </b-card>
        </b-colxx>
      </b-row>
      <div v-else class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>

      <template slot="modal-footer">
        <b-button variant="secondary" @click="hideModal('editCategoryModal')">
          {{ $t('buttons.cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { handleArrayDataInternalization } from '@/utils'
import { apiUrl } from '@/constants/config'
const { required } = require('vuelidate/lib/validators')

export default {
  props: {
    linkList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      apiUrl,
      ctLoading: false,
      // Har bir rasm uchun alohida state
      imageEnUploaded: false,
      imageRuUploaded: false,
      imageEnUrl: null,
      imageRuUrl: null,
      editForm: {
        link: '',
        image_en: null,
        image_ru: null,
        active: false,
        categoryId: null,
        mobile: false
      },
      currentLink: null
    }
  },
  validations: {
    editForm: {
      link: { required }
    }
  },
  computed: {
    requirements() {
      const requirements = this.$store.getters['manufacturers/requirements']
      return handleArrayDataInternalization(requirements, ['name'], this.$i18n.locale)
    }
  },
  mounted() {
    this.fetchRequirements()
    this.$root.$on('bv::modal::show', (_bvEvent, modalId) => {
      if (modalId === 'editCategoryModal') {
        this.clearForm()
      }
    })
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 3000, permanent: false })
    },
    fetchRequirements() {
      this.$store.dispatch('manufacturers/fetchRequirements')
    },
    handleDelete(id) {
      this.$confirm({
        message: this.$t('confirm-dialog.question'),
        button: {
          no: this.$t('confirm-dialog.no'),
          yes: this.$t('confirm-dialog.yes')
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('links/deleteCategory', {
              id,
              vm: this
            })
          }
        }
      })
    },

    showInfoModal(id) {
      this.$bvModal.show('editCategoryModal')
      this.$store.dispatch('links/fetchCategory', { id, vm: this })
      this.currentLink = id
    },

    // EN rasm uchun alohida method
    onImageEnChange(event) {
      this.imageEnUploaded = !!event.target.files.length
    },

    // RU rasm uchun alohida method
    onImageRuChange(event) {
      this.imageRuUploaded = !!event.target.files.length
    },

    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          link: this.editForm.link,
          image_en: this.editForm.image_en || '',
          image_ru: this.editForm.image_ru || '',
          active: this.editForm.active ? '1' : '0',
          category_id: this.editForm.categoryId || null,
          mobile: this.editForm.mobile ? '1' : '0'
        }

        this.$store.dispatch('links/updateCategory', {
          payload,
          id: this.currentLink,
          vm: this
        })
      }
    },

    clearForm() {
      this.editForm.link = ''
      this.editForm.image_en = null
      this.editForm.image_ru = null
      this.editForm.active = false
      this.editForm.categoryId = null
      this.editForm.mobile = false
      // Rasm state larini ham tozalash
      this.imageEnUploaded = false
      this.imageRuUploaded = false
      this.imageEnUrl = null
      this.imageRuUrl = null
      this.currentLink = null
      // Validation xatolarini tozalash
      this.$v.$reset()
    },

    hideModal(refname) {
      this.$refs[refname].hide()
    }
  }
}
</script>
